var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.827 7.50042C23.513 7.47528 22.4375 8.57579 22.4375 9.89005V15H21.9687V4.67521C21.9687 3.36095 20.8932 2.26044 19.5792 2.28558C18.3059 2.30995 17.2812 3.34976 17.2812 4.62892V15H16.8125V2.39005C16.8125 1.07579 15.737 -0.0247144 14.423 0.000422273C13.1497 0.0247973 12.125 1.0646 12.125 2.34376V15H11.6562V4.7338C11.6562 3.41954 10.5807 2.31903 9.26674 2.34417C7.99344 2.36855 6.96875 3.40835 6.96875 4.68751V18.5152L5.11438 15.9652C4.35307 14.9184 2.88729 14.6869 1.84033 15.4482C0.793557 16.2096 0.562111 17.6754 1.32342 18.7223L8.68285 28.8417C8.94377 29.2005 9.28585 29.4924 9.68116 29.6938C10.0765 29.8951 10.5138 30 10.9574 30H22.5349C23.8401 30 24.9737 29.1021 25.2727 27.8317L26.8259 21.2305C27.0246 20.386 27.1249 19.5214 27.1249 18.6539V9.84376C27.125 8.5646 26.1003 7.5248 24.827 7.50042Z",
    fill: "#2948A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.1099123e615e34f6a60cd6fd5fcd5109.svg";
export { ForwardRef as ReactComponent };